import styles from "./Checkbox.module.scss";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import { CheckIcon, LessIcon } from "app/icons/navigation";
import classNames from "classnames";
import { useState } from "react";

export type CheckboxProps = { error?: boolean; id: string } & CheckboxPrimitive.CheckboxProps;

export const Checkbox = ({
	id,
	className,
	checked,
	defaultChecked,
	onCheckedChange,
	error,
	value,
	...props
}: CheckboxProps) => {
	const isControlled = checked !== undefined;
	const [internalChecked, setInternalChecked] = useState(defaultChecked ?? false);
	const state = isControlled ? checked : internalChecked;

	return (
		<CheckboxPrimitive.Root
			className={classNames(
				styles["checkbox"],
				{ [styles["checkbox--error"]]: error },
				className
			)}
			id={id}
			checked={state}
			onCheckedChange={value => {
				if (!isControlled) {
					setInternalChecked(value);
				}

				onCheckedChange?.(value);
			}}
			value={value}
			{...props}
		>
			<CheckboxPrimitive.Indicator className={styles["checkbox__indicator"]}>
				{state === "indeterminate" ? (
					<LessIcon height={12} width={12} color="white" />
				) : (
					<CheckIcon height={12} width={12} color="white" />
				)}
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	);
};
